import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const Nav = styled(motion.nav)<{ scrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: ${({ scrolled }) => (scrolled ? '1rem 2.5rem' : '1.5rem 2.5rem')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ scrolled }) =>
    scrolled ? 'rgba(246, 242, 236, 0.85)' : 'transparent'};
  backdrop-filter: ${({ scrolled }) => (scrolled ? 'blur(12px)' : 'none')};
  border-bottom: ${({ scrolled }) =>
    scrolled ? '1px solid var(--border)' : '1px solid transparent'};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 1rem 1.25rem;
  }
`;

const Logo = styled(NavLink)`
  font-family: var(--font-display);
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text);
  text-decoration: none;

  &:hover {
    color: var(--text);
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 2.5rem;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

const StyledNavLink = styled(NavLink)`
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
  text-decoration: none;
  position: relative;
  padding-bottom: 2px;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1.5px;
    background: var(--accent);
    transition: width 0.3s ease;
  }

  &:hover {
    color: var(--text);
    &::after {
      width: 100%;
    }
  }

  &.active {
    color: var(--accent);
    &::after {
      width: 100%;
    }
  }
`;

const Navigation: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Nav
      scrolled={scrolled}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <Logo to="/">Aaron Leslie</Logo>
      <NavLinks>
        <StyledNavLink to="/" end>
          Home
        </StyledNavLink>
        <StyledNavLink to="/blog">Blog</StyledNavLink>
      </NavLinks>
    </Nav>
  );
};

export default Navigation;
